module.exports = __webpack_public_path__ + "static/media/img_medpreve_min.f8637b3a.jpg";